expect fun getClientConfig(): ConfigFile

data class ConfigFile(
    var shouldShowScrollBar: Boolean,
)